import Gestion from "../Gestion/Gestion";
function EmpresasProveedorasdeEstadoNacional() {
  const textos = [
  ' Asistimos a empresas nacionales y extranjeras en el proceso de inscripción como proveedoras del Estado Nacional, requisito indispensable para participar en licitaciones públicas, contrataciones directas y concursos del sector público. ',

' Nuestro servicio incluye el análisis previo de la estructura societaria, la gestión completa del trámite ante los organismos correspondientes (SIPRO / COMPR.AR / registros complementarios) y el acompañamiento jurídico hasta la obtención efectiva de la habilitación, asegurando el cumplimiento de la normativa vigente y evitando observaciones que demoren o frustren el procedimiento. ',

' Contamos con experiencia concreta en la materia y un enfoque práctico orientado a resultados, lo que permite a nuestros clientes acceder al mercado de compras públicas de manera ágil, segura y eficiente. ',

' Brindamos asesoramiento personalizado, adaptando el proceso a las particularidades de cada empresa y al tipo de contratación estatal que se busca alcanzar; Convertimos los requisitos legales en una oportunidad concreta de negocio con el Estado. '


  ];

  return (
    <>
      <Gestion titulo={"Inscripción de empresas como proveedoras del estado nacional"} textoServicio={textos}/>
    </>
  );
}

export default EmpresasProveedorasdeEstadoNacional;
